
import Vue from 'vue';
/**
- The card shadow depends on the given props <b>elevation</b>.
- Sort by from thin to thick: <i>thin, interactive, float</i>.
**/
export default Vue.extend<any, any, any, any>({
  name: 'Card',
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set card elevation type (sort by thickness: thin, interactive, float, thicker)
     */
    elevation: {
      type: String,
      default: ''
    },
    /*
     * Set card on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set card on success state
     */
    success: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClasses() {
      return {
        thin: this.elevation === 'thin',
        interactive: this.elevation === 'interactive',
        float: this.elevation === 'float',
        thicker: this.elevation === 'thicker',
        error: this.error,
        success: this.success
      };
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Method when card is click
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
